import $ from "../lib/jquery.js";
import { debounce } from "../lib/dom.js";

/*
 * The overlay registration form. On phones it fills the viewport; on larger
 * screens it slides down to the vertical centre.
 */

function position($slider) {
  const isPhone = window.matchMedia("(max-width: 480px)").matches;

  if (isPhone) {
    $slider.css({ position: "fixed", top: 0 });
    $slider.find(".form-slider-inner").css({
      height: `${window.innerHeight}px`,
      width: "100%",
      padding: "60px 0 0 0",
    });
    $slider.find(".form-close").css({ top: "16px", right: "16px" });
    return;
  }

  $slider.css({ position: "absolute" });
  $slider.find(".form-slider-inner").css({ height: "", width: "", padding: "" });
  $slider.find(".form-close").css({ top: "", right: "" });
  $slider.animate({ top: `${Math.max((window.innerHeight - $slider.height()) / 2, 0)}px` }, 600);
}

export default function initFormSlider() {
  const $slider = $(".form-slider");

  if (!$slider.length) {
    return;
  }

  position($slider);

  $slider.on("click", ".form-close", () => $slider.fadeOut(400));

  window.addEventListener(
    "resize",
    debounce(() => position($slider), 150),
  );
}
